/* ══════════════════════════════════════════════════
   assets/mega-menu.js — Mega Menú JSON (MM51)
   Vanilla JS — sin dependencias externas.
   Requiere: window.MM51_DATA (inyectado desde metafield shop)
══════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Estado ──────────────────────────────────── */
  var menuData   = null;
  var activePanel = null;
  var closeTimer  = null;
  var globalEventsAttached = false;
  var openRafId   = null;

  /* ── Helper de extracción de texto robusto ───── */
  function _getText(obj) {
    if (!obj) return '';
    if (typeof obj === 'string') return obj;
    if (typeof obj === 'number') return String(obj);
    
    var text = obj.label || obj.title || obj.name || obj.text || obj.heading || obj.tab_title || obj.category_name;
    
    if (typeof text === 'object' && text !== null) {
      return text.value || text.es || text.en || '';
    }
    
    return text || '';
  }

  /* ── Helper para obtener configuración de destacado desde el Header ───── */
  function getHeaderHighlightConfig() {
    var headerEl = document.querySelector('header.theme__header[data-featured-link]');
    if (!headerEl) return null;

    var link = headerEl.getAttribute('data-featured-link') || '';
    var color = headerEl.getAttribute('data-featured-color') || '';

    if (!link.trim()) return null;

    return {
      item: link.trim().toLowerCase(),
      color: color.trim()
    };
  }

  /* ── Selectores ──────────────────────────────── */
  function getNavbar()  { return document.getElementById('mm51-navbar'); }
  function getPanels()  { return document.getElementById('mm51-panels'); }
  function getOverlay() { return document.getElementById('mm51-overlay'); }

  /* ── Posición del panel ──────────────────────── */
  function setMmTop() {
    var navbar = getNavbar();
    if (!navbar) return;
    var bottom = navbar.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--mm51-top', bottom + 'px');
  }

  /* ── Búsqueda inteligente de MegaMenú ── */
  function findMegamenu(id) {
    if (!menuData || !menuData.megamenus) return null;

    // 1. Intentar buscar por ID exacto
    var mm = menuData.megamenus.find(function (m) { 
      return m.id === id && m.tabs && m.tabs.length > 0; 
    });

    if (mm) return mm;

    // 2. Fallback: Buscar por el label del item del navbar
    var navItem = (menuData.navbar.items || []).find(function (item) { return item.id === id; });
    if (!navItem) return null;

    var navLabel = _getText(navItem).toLowerCase().trim();

    return menuData.megamenus.find(function (m) {
      var mmLabel = _getText(m).toLowerCase().trim();
      return (mmLabel === navLabel || m.id === navLabel) && m.tabs && m.tabs.length > 0;
    });
  }

  /* ── Obtener Nombre del Menú (Con Fallback al Navbar) ── */
  function getMegamenuLabel(mm) {
    var label = _getText(mm);
    if (label) return label;

    var navItem = (menuData.navbar.items || []).find(function (item) { 
      return item.id === mm.id || (item.label || '').toLowerCase().trim() === (mm.id || '').toLowerCase().trim();
    });

    return navItem ? _getText(navItem) : '';
  }

  /* ── Abrir panel ─────────────────────────────── */
  function openPanel(id) {
    var mm = findMegamenu(id);
    if (!mm) return;

    var targetPanelId = 'mm51-panel-' + mm.id;
    if (!document.getElementById(targetPanelId)) return;

    clearTimeout(closeTimer);
    if (openRafId) cancelAnimationFrame(openRafId);

    _closeNow();

    activePanel = mm.id;
    setMmTop();

    if (mm.tabs && mm.tabs.length) {
      switchTab(mm.id, mm.tabs[0].id);
    }

    var panel   = document.getElementById(targetPanelId);
    var overlay = getOverlay();
    var navItem = document.querySelector('[data-mm-id="' + id + '"]');

    if (panel) {
      openRafId = requestAnimationFrame(function () {
        openRafId = requestAnimationFrame(function () {
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
        });
      });
    }
    if (overlay) overlay.classList.add('is-visible');
    if (navItem) navItem.setAttribute('aria-expanded', 'true');
  }

  /* ── Cerrar inmediatamente ───────────────────── */
  function _closeNow() {
    if (openRafId) cancelAnimationFrame(openRafId);

    var allPanels = document.querySelectorAll('.mm51-panel.is-open');
    Array.from(allPanels).forEach(function(p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });

    var allNavItems = document.querySelectorAll('[data-mm-id]');
    Array.from(allNavItems).forEach(function(ni) {
      ni.setAttribute('aria-expanded', 'false');
    });

    var overlay = getOverlay();
    if (overlay) overlay.classList.remove('is-visible');

    activePanel = null;
  }

  /* ── Cerrar con delay (para hover) ──────────── */
  function scheduleClose() {
    closeTimer = setTimeout(_closeNow, 120);
  }

  /* ── Cancelar cierre pendiente ───────────────── */
  function cancelClose() {
    clearTimeout(closeTimer);
  }

  /* ── Cambio de tab ───────────────────────────── */
  function switchTab(panelId, tabId) {
    var panelEl = document.getElementById('mm51-panel-' + panelId);
    if (!panelEl) return;

    Array.from(panelEl.querySelectorAll('.mm51-tab')).forEach(function (btn) {
      var active = btn.dataset.tabId === tabId;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    Array.from(panelEl.querySelectorAll('.mm51-tab-panel')).forEach(function (tp) {
      tp.classList.toggle('is-active', tp.dataset.tabPanel === tabId);
    });

    updateTabAction(panelEl, panelId, tabId);
  }

  /* ── CTA del tab activo en el header del panel ───── */
  function updateTabAction(panelEl, panelId, tabId) {
    var action = panelEl.querySelector('.mm51-tabs-nav__action');
    if (!action || !menuData) return;

    var mm = (menuData.megamenus || []).find(function (m) { return m.id === panelId; });
    var tab = mm && (mm.tabs || []).find(function (t) { return t.id === tabId; });
    var hasSizeGrid = tab && (tab.columns || []).some(function (col) {
      return col.type === 'size-grid';
    });

    if (!tab || !tab.footer || !tab.footer.url || hasSizeGrid) {
      action.classList.add('is-hidden');
      action.removeAttribute('href');
      action.textContent = '';
      return;
    }

    var tabLabel = _getText(tab);
    action.href = tab.footer.url;
    action.textContent = 'Ver todo ' + tabLabel;
    action.classList.remove('is-hidden');
  }

  /* ════════════════════════════════════════════════
     BUILDERS — columnas
  ════════════════════════════════════════════════ */

  function buildLinksColumn(col) {
    var div = document.createElement('div');
    div.className = 'mm51-col mm51-col--links';
    _appendTitle(div, _getText(col.title || col));

    var ul = document.createElement('ul');
    ul.className = 'mm51-links';
    (col.links || []).forEach(function (link) {
      var li = document.createElement('li');
      li.appendChild(_linkEl(link.url, _getText(link), 'mm51-link'));
      ul.appendChild(li);
    });
    div.appendChild(ul);
    return div;
  }

  function buildLinksMulticolumn(col) {
    var div = document.createElement('div');
    div.className = 'mm51-col mm51-col--links-multicolumn';
    _appendTitle(div, _getText(col.title || col));

    var inner = document.createElement('div');
    inner.className = 'mm51-multicolumn';

    (col.columns || []).forEach(function (subLinks) {
      var subDiv = document.createElement('div');
      subDiv.className = 'mm51-multicolumn__col';
      var ul = document.createElement('ul');
      ul.className = 'mm51-links';
      subLinks.forEach(function (link) {
        var li = document.createElement('li');
        li.appendChild(_linkEl(link.url, _getText(link), 'mm51-link'));
        ul.appendChild(li);
      });
      subDiv.appendChild(ul);
      inner.appendChild(subDiv);
    });
    div.appendChild(inner);
    return div;
  }

  function buildImagesColumn(col) {
    var div = document.createElement('div');
    div.className = 'mm51-col mm51-col--images';
    _appendTitle(div, _getText(col.title || col));

    var inner = document.createElement('div');
    inner.className = 'mm51-images';

    (col.images || []).forEach(function (img) {
      var a = document.createElement('a');
      a.href = img.url;
      a.className = 'mm51-imglink';

      var imgEl = document.createElement('img');
      imgEl.src = img.src;
      imgEl.alt = img.alt || _getText(img) || '';
      imgEl.loading = 'lazy';
      imgEl.className = 'mm51-imglink__img';
      a.appendChild(imgEl);

      var captionText = img.alt || _getText(img);
      if (captionText) {
        var cap = document.createElement('span');
        cap.className = 'mm51-imglink__caption';
        cap.textContent = captionText;
        a.appendChild(cap);
      }
      inner.appendChild(a);
    });
    div.appendChild(inner);
    return div;
  }

  function buildSizeGrid(col) {
    var div = document.createElement('div');
    div.className = 'mm51-col mm51-col--size-grid';
    _appendTitle(div, _getText(col.title || col));

    var grid = document.createElement('div');
    grid.className = 'mm51-size-grid';
    (col.sizes || []).forEach(function (size) {
      grid.appendChild(_linkEl(size.url, _getText(size), 'mm51-size'));
    });
    div.appendChild(grid);
    return div;
  }

  function buildColumn(col) {
    var el;
    switch (col.type) {
      case 'links':             el = buildLinksColumn(col);     break;
      case 'links-multicolumn': el = buildLinksMulticolumn(col); break;
      case 'images':            el = buildImagesColumn(col);    break;
      case 'size-grid':         el = buildSizeGrid(col);        break;
      default:
        el = document.createElement('div');
        el.className = 'mm51-col';
    }

    var w = col.width || {};
    el.style.setProperty('--col-desktop', w.desktop || 3);
    el.style.setProperty('--col-tablet',  w.tablet  || 6);
    el.style.setProperty('--col-mobile',  w.mobile  || 12);

    return el;
  }

  /* ════════════════════════════════════════════════
     BUILDERS — tab panel
  ════════════════════════════════════════════════ */
  function buildTabPanel(tab, megaId, isActive) {
    var panel = document.createElement('div');
    panel.className = 'mm51-tab-panel' + (isActive ? ' is-active' : '');
    panel.dataset.tabPanel = tab.id;
    panel.setAttribute('role', 'tabpanel');
    panel.id = 'mm51-tp-' + megaId + '-' + tab.id;
    panel.setAttribute('aria-labelledby', 'mm51-tb-' + megaId + '-' + tab.id);

    var grid = document.createElement('div');
    grid.className = 'mm51-grid';
    (tab.columns || []).forEach(function (col) {
      grid.appendChild(buildColumn(col));
    });
    panel.appendChild(grid);

    if (tab.footer) {
      var footer = document.createElement('div');
      footer.className = 'mm51-tab-footer';
      if (tab.footer.type === 'button') {
        var a = document.createElement('a');
        a.href    = tab.footer.url;
        a.className = 'btn btn--solid btn--black';
        a.textContent = _getText(tab.footer) || 'Ver productos';
        footer.appendChild(a);
      }
      panel.appendChild(footer);
    }

    return panel;
  }

  /* ════════════════════════════════════════════════
     BUILDERS — mega panel (overlay)
  ════════════════════════════════════════════════ */
  function buildMegaPanel(mm) {
    var wrapper = document.createElement('div');
    wrapper.className = 'mm51-panel';
    wrapper.id = 'mm51-panel-' + mm.id;
    wrapper.setAttribute('aria-hidden', 'true');

    var inner = document.createElement('div');
    inner.className = 'mm51-panel__inner';

    var categoryTitleText = getMegamenuLabel(mm);

    var tabs = mm.tabs || [];
    if (tabs.length) {
      var nav = document.createElement('nav');
      nav.className = 'mm51-tabs-nav';
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', categoryTitleText);

      var tabsListWrap = document.createElement('div');
      tabsListWrap.className = 'mm51-tabs-list';

      tabs.forEach(function (tab, i) {
        var isActive = i === 0;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mm51-tab' + (isActive ? ' is-active' : '');
        btn.id = 'mm51-tb-' + mm.id + '-' + tab.id;
        btn.dataset.tabId = tab.id;
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('aria-controls', 'mm51-tp-' + mm.id + '-' + tab.id);
        btn.textContent = _getText(tab);

        btn.addEventListener('click', (function (tid) {
          return function () { switchTab(mm.id, tid); };
        })(tab.id));
        tabsListWrap.appendChild(btn);
      });

      nav.appendChild(tabsListWrap);

      var action = document.createElement('a');
      action.className = 'mm51-tabs-nav__action is-hidden';
      nav.appendChild(action);
      inner.appendChild(nav);

      var tabPanelsWrap = document.createElement('div');
      tabPanelsWrap.className = 'mm51-tab-panels';
      tabs.forEach(function (tab, i) {
        tabPanelsWrap.appendChild(buildTabPanel(tab, mm.id, i === 0));
      });
      inner.appendChild(tabPanelsWrap);
    }

    wrapper.appendChild(inner);

    wrapper.addEventListener('mouseenter', cancelClose);
    wrapper.addEventListener('mouseleave', scheduleClose);

    return wrapper;
  }

  /* ════════════════════════════════════════════════
     BUILDERS — nav item (barra superior)
  ════════════════════════════════════════════════ */
  function buildNavItem(item) {
    var el = document.createElement('div');
    el.className = 'mm51-nav-item';
    el.dataset.mmId = item.id;

    if (item.type === 'megamenu') {
      el.setAttribute('aria-haspopup', 'true');
      el.setAttribute('aria-expanded', 'false');
    }

    var a = document.createElement('a');
    a.href = item.url || '#';
    a.className = 'navlink navlink--toplevel';

    if (item.style) {
      Object.keys(item.style).forEach(function (k) {
        a.style.setProperty(k, item.style[k]);
      });
    }

    var itemText = _getText(item);

    /* HIGHLIGHT SOLO A NIVEL NAV */
    var highlightConfig = getHeaderHighlightConfig();
    if (highlightConfig && highlightConfig.item) {
      if (itemText.trim().toLowerCase() === highlightConfig.item) {
        a.classList.add('is-highlighted');
        if (highlightConfig.color) {
          a.style.color = highlightConfig.color;
        }
        a.style.fontWeight = '700';
      }
    }

    var span = document.createElement('span');
    span.className = 'navtext';
    span.textContent = itemText;
    a.appendChild(span);
    el.appendChild(a);

    if (item.type === 'megamenu') {
      el.addEventListener('mouseenter', (function (id) {
        return function () { cancelClose(); openPanel(id); };
      })(item.id));

      el.addEventListener('mouseleave', scheduleClose);

      a.addEventListener('keydown', (function (id) {
        return function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (activePanel === id) _closeNow();
            else openPanel(id);
          }
        };
      })(item.id));
    }

    return el;
  }

  /* ════════════════════════════════════════════════
     RENDER & EVENTOS
  ════════════════════════════════════════════════ */
  function render() {
    var navbar    = getNavbar();
    var panelsCtr = getPanels();
    if (!navbar || !panelsCtr || !menuData) return;

    navbar.innerHTML = '';
    (menuData.navbar.items || []).forEach(function (item) {
      navbar.appendChild(buildNavItem(item));
    });

    panelsCtr.innerHTML = '';
    (menuData.megamenus || []).forEach(function (mm) {
      if (mm.tabs && mm.tabs.length > 0) {
        panelsCtr.appendChild(buildMegaPanel(mm));
      }
    });
  }

  function attachGlobalEvents() {
    var overlay = getOverlay();
    if (overlay && overlay.dataset.mm51Bound !== 'true') {
      overlay.addEventListener('click', _closeNow);
      overlay.dataset.mm51Bound = 'true';
    }

    if (globalEventsAttached) return;
    globalEventsAttached = true;

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activePanel) _closeNow();
    });

    window.addEventListener('resize', setMmTop, { passive: true });
  }

  function _linkEl(href, text, cls) {
    var a = document.createElement('a');
    a.href = href;
    a.className = cls;
    a.textContent = text;
    return a;
  }

  function _appendTitle(parent, title) {
    if (!title) return;
    var p = document.createElement('p');
    p.className = 'mm51-col__title';
    p.textContent = title;
    parent.appendChild(p);
  }

  function _arrowSvg() {
    return '<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10.5" cy="10.5" r="10.5" fill="#F4EFE9"/><path d="M8.53125 6.5625L12.4688 10.596L8.53125 14.4375" stroke="#534438" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function _appendMobileTabFooter(panel, tab) {
    if (!tab.footer) return;

    var footer = document.createElement('div');
    footer.className = 'mm51-mpanel__tab-footer';

    if (tab.footer.type === 'button') {
      var btn = document.createElement('a');
      btn.href = tab.footer.url;
      btn.className = 'mm51-mpanel__tab-footer-btn';
      btn.textContent = 'Ver más ' + _getText(tab);
      footer.appendChild(btn);
    }

    panel.appendChild(footer);
  }

  /* ════════════════════════════════════════════════
     MOBILE DRAWER
  ════════════════════════════════════════════════ */
  var mobileDrawer = {
    container: null,
    overlay: null,
    panelStack: [],
    isOpen: false,
    isInitialized: false,
    secondaryLinks: [],
    showSearch: true,

    init: function() {
      if (this.isInitialized) {
        this.attachMobileEvents();
        return;
      }

      var openBtn = document.querySelector('[data-mm51-open]');
      if (openBtn && openBtn.dataset.mm51ShowSearch !== undefined) {
        this.showSearch = openBtn.dataset.mm51ShowSearch !== 'false';
      }

      this.collectSecondaryLinks();
      this.buildDrawerDOM();
      this.attachMobileEvents();
      this.isInitialized = true;
    },

    collectSecondaryLinks: function() {
      var links = [];
      var containerExtras = document.querySelector('.container-extras');
      if (containerExtras) {
        var extraLinks = containerExtras.querySelectorAll('a.icon-nav');
        extraLinks.forEach(function(link) {
          var text = link.querySelector('span');
          if (text && link.href) { 
            links.push({
              label: text.textContent.trim(),
              url: link.getAttribute('href')
            });
          }
        });
      }

      if (links.length === 0) {
        var accountLink = document.querySelector('a[href*="/account"]');
        if (accountLink) {
          links.push({ label: 'Mi cuenta', url: '/account' });
        }

        var trackLink = document.querySelector('[href*="seguimiento"], [href*="track"]');
        if (trackLink) {
          links.push({
            label: trackLink.textContent.trim(),
            url: trackLink.getAttribute('href')
          });
        }

        var helpLink = document.querySelector('[href*="/pages/centro-de-ayuda"], [href*="/pages/help"], [href*="/pages/centro"]');
        if (helpLink) {
          links.push({
            label: helpLink.textContent.trim(),
            url: helpLink.getAttribute('href')
          });
        }
      }

      this.secondaryLinks = links;
    },

    buildDrawerDOM: function() {
      var existingDrawer = document.getElementById('mm51-mobile-drawer');
      if (existingDrawer) {
        this.container = existingDrawer;
        this.overlay = existingDrawer.querySelector('.mm51-mdrawer__overlay');
        this.panelsContainer = existingDrawer.querySelector('.mm51-mdrawer__panels');
        return;
      }

      var drawer = document.createElement('div');
      drawer.id = 'mm51-mobile-drawer';
      drawer.className = 'mm51-mdrawer';
      drawer.setAttribute('aria-hidden', 'true');

      var overlay = document.createElement('div');
      overlay.className = 'mm51-mdrawer__overlay';
      overlay.addEventListener('click', this.close.bind(this));

      var inner = document.createElement('div');
      inner.className = 'mm51-mdrawer__inner';

      var panelsContainer = document.createElement('div');
      panelsContainer.className = 'mm51-mdrawer__panels';
      panelsContainer.id = 'mm51-mdrawer-panels';

      inner.appendChild(panelsContainer);
      drawer.appendChild(overlay);
      drawer.appendChild(inner);
      document.body.appendChild(drawer);

      this.container = drawer;
      this.overlay = overlay;
      this.panelsContainer = panelsContainer;
    },

    attachMobileEvents: function() {
      var self = this;
      var openBtns = document.querySelectorAll('[data-mm51-open]');

      openBtns.forEach(function(openBtn) {
        if (openBtn.dataset.mm51Bound === 'true') return;

        openBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.open();
        }, true);

        openBtn.dataset.mm51Bound = 'true';
        openBtn.setAttribute('aria-haspopup', 'dialog');
        openBtn.setAttribute('aria-controls', 'mm51-mobile-drawer');
        openBtn.setAttribute('aria-expanded', 'false');
      });

      if (!this.escapeBound) {
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && self.isOpen) {
            self.close();
          }
        });
        this.escapeBound = true;
      }
    },

    open: function() {
      if (!menuData) return;

      this.isOpen = true;
      this.panelStack = [];
      this.renderPanel1();

      this.container.classList.add('is-open');
      this.container.setAttribute('aria-hidden', 'false');
      this.updateTriggerState(true);
      document.documentElement.classList.add('mm51-no-scroll');
      document.body.classList.add('mm51-no-scroll');
    },

    close: function() {
      this.isOpen = false;
      this.container.classList.remove('is-open');
      this.container.setAttribute('aria-hidden', 'true');
      this.updateTriggerState(false);
      document.documentElement.classList.remove('mm51-no-scroll');
      document.body.classList.remove('mm51-no-scroll');

      var self = this;
      setTimeout(function() {
        self.panelsContainer.innerHTML = '';
        self.panelStack = [];
      }, 300);
    },

    updateTriggerState: function(isExpanded) {
      document.querySelectorAll('[data-mm51-open]').forEach(function(openBtn) {
        openBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    },

    renderPanel1: function() {
      var panel = document.createElement('div');
      panel.className = 'mm51-mpanel mm51-mpanel--1 is-active';
      panel.dataset.level = '1';

      var header = document.createElement('div');
      header.className = 'mm51-mpanel__header';

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'mm51-mpanel__close';
      closeBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      closeBtn.addEventListener('click', this.close.bind(this));

      header.appendChild(closeBtn);
      panel.appendChild(header);

      if (this.showSearch) {
        var searchBar = document.createElement('div');
        searchBar.className = 'mm51-mpanel__search';
        searchBar.innerHTML = '<div class="mm51-mpanel__search-inner">' +
          '<input type="search" placeholder="¿Qué estás buscando?" class="mm51-mpanel__search-input" />' +
          '<button type="button" class="mm51-mpanel__search-btn">' +
            '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4985 12.4985L16.5 16.5M14.4993 7.49964C14.4993 11.3669 11.3669 14.4993 7.49964 14.4993C3.63234 14.4993 0.5 11.3669 0.5 7.49964C0.5 3.63234 3.63234 0.5 7.49964 0.5C11.3669 0.5 14.4993 3.63234 14.4993 7.49964Z" stroke="#222222" stroke-linecap="square" stroke-linejoin="round"/></svg>' +
          '</button>' +
        '</div>';

        var searchInput = searchBar.querySelector('.mm51-mpanel__search-input');
        var searchBtn = searchBar.querySelector('.mm51-mpanel__search-btn');

        var handleSearch = function() {
          var query = searchInput.value.trim();
          if (query.length > 0) {
            window.location.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
          }
        };

        searchBtn.addEventListener('click', handleSearch);
        searchInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
          }
        });

        panel.appendChild(searchBar);
      }

      var body = document.createElement('div');
      body.className = 'mm51-mpanel__body';

      var list = document.createElement('ul');
      list.className = 'mm51-mlist';

      var navbar = menuData.navbar;
      if (navbar && navbar.items) {
        navbar.items.forEach(function(item) {
          var li = document.createElement('li');
          li.className = 'mm51-mlist__item';
          var itemLabel = _getText(item);

          if (item.type !== 'megamenu') {
            var aSimple = document.createElement('a');
            aSimple.href = item.url || '#';
            aSimple.className = 'mm51-mlist__link';
            if (item.style && item.style.color) aSimple.style.color = item.style.color;

            var spanSimple = document.createElement('span');
            spanSimple.textContent = itemLabel;
            
            aSimple.appendChild(spanSimple);
            li.appendChild(aSimple);
          } 
          else {
            var wrapper = document.createElement('div');
            wrapper.className = 'mm51-mlist__link';
            wrapper.style.display = 'flex';
            wrapper.style.justifyContent = 'space-between';
            wrapper.style.alignItems = 'center';
            wrapper.style.padding = '0';

            if (item.style && item.style.color) {
              wrapper.style.color = item.style.color;
            }

            var textLink = document.createElement('a');
            textLink.href = item.url || '#';
            textLink.style.color = 'inherit';
            textLink.style.flexGrow = '1';
            textLink.style.textDecoration = 'none';
            
            var spanText = document.createElement('span');
            spanText.textContent = itemLabel;
            textLink.appendChild(spanText);

            var arrowLink = document.createElement('a');
            arrowLink.href = '#';
            arrowLink.className = 'mm51-mlist__arrow';
            arrowLink.style.color = 'inherit';
            arrowLink.style.display = 'flex';
            arrowLink.style.alignItems = 'center';

            var svgContainer = document.createElement('div');
            svgContainer.className = 'container-svg';
            svgContainer.innerHTML = _arrowSvg();
            
            arrowLink.appendChild(svgContainer);

            arrowLink.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              mobileDrawer.goToPanel2(item.id, itemLabel);
            });

            wrapper.appendChild(textLink);
            wrapper.appendChild(arrowLink);
            li.appendChild(wrapper);
          }

          list.appendChild(li);
        });
      }

      body.appendChild(list);

      if (this.secondaryLinks.length > 0) {
        var footer = document.createElement('div');
        footer.className = 'mm51-mpanel__footer';

        this.secondaryLinks.forEach(function(link) {
          var a = document.createElement('a');
          a.href = link.url;
          a.className = 'mm51-mpanel__footer-link';
          
          var linkText = _getText(link);
          var lowerText = linkText.toLowerCase();
          var svgIcon = '';

          if (lowerText.includes('cuenta')) {
            svgIcon = '<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.66148 7.85701C4.46362 7.85701 2.67374 6.10957 2.654 3.94792C2.64084 1.78627 4.45046 0 6.66148 0C8.87251 0 10.6821 1.78627 10.669 3.94792C10.6492 6.11604 8.86593 7.85701 6.66148 7.85701ZM6.67465 6.73088C8.24079 6.73088 9.50424 5.48179 9.51082 3.93498C9.51082 2.37523 8.22763 1.11318 6.64832 1.11966C5.08218 1.12613 3.81874 2.3817 3.81216 3.92203C3.81216 5.48179 5.08218 6.73736 6.67465 6.73088Z" fill="#534438"/><path d="M6.68123 8.88625C10.2149 8.89272 13.1498 11.6498 13.3275 15.1188C13.3275 15.2353 13.3406 15.3583 13.3275 15.4747C13.288 15.7983 13.0445 16.0184 12.7352 15.999C12.4062 15.9731 12.2351 15.7919 12.1956 15.4683C12.1364 14.9958 12.1167 14.5169 11.9916 14.0639C11.3204 11.5398 8.85935 9.7988 6.3193 10.0253C3.40419 10.2842 1.36425 12.3229 1.14051 15.1965C1.13393 15.2871 1.14051 15.3841 1.12735 15.4747C1.08787 15.8178 0.897037 16.0119 0.548273 15.999C0.19951 15.986 -0.0242251 15.766 0.00209663 15.4359C0.0547402 14.8211 0.100803 14.1933 0.271895 13.6043C1.08129 10.7955 3.71347 8.87977 6.68123 8.88625Z" fill="#534438"/></svg>';
          } 
          else if (lowerText.includes('sigue tu compra') || lowerText.includes('seguimiento')) {
            svgIcon = '<svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.02619 0H12.7105C14.1522 0 15.324 0.984618 15.6424 2.33844H17.4315C19.2473 2.33844 20.8209 3.44614 21.4262 5.04617L22.8789 8.73841C23 8.98467 23 9.10763 23 9.35382V11.6923C23 12.4812 22.454 13.1815 21.7398 13.4339C21.505 14.9047 20.2848 16 18.7631 16C17.2766 16 16.0697 14.9575 15.7961 13.5384H15.1316H8.41435C8.14072 14.9576 6.93385 16 5.44737 16C3.96088 16 2.75391 14.9575 2.48037 13.5384H1.81581C0.847383 13.5384 1.08646e-08 12.6769 1.08646e-08 11.6923V3.07692C-0.000138884 1.35382 1.33149 0 3.02619 0ZM18.7631 14.7693C19.7316 14.7693 20.5789 13.9077 20.5789 12.923C20.5789 11.9384 19.7316 11.0769 18.7631 11.0769C17.7947 11.0769 16.9473 11.9384 16.9473 12.923C16.9473 13.9077 17.7947 14.7693 18.7631 14.7693ZM18.7631 9.84613C20.0874 9.84613 21.1806 10.6781 21.5994 11.8621C21.6406 11.776 21.6684 11.6812 21.6684 11.5691V9.23072L20.2157 5.53835C19.7316 4.3076 18.6421 3.5691 17.4315 3.5691H15.7368V12.3076H15.796C16.0697 10.8886 17.2766 9.84613 18.7631 9.84613ZM5.4473 14.7693C6.41571 14.7693 7.26313 13.9077 7.26313 12.923C7.26313 11.9384 6.41571 11.0769 5.4473 11.0769C4.47886 11.0769 3.63148 11.9384 3.63148 12.923C3.63148 13.9077 4.47886 14.7693 5.4473 14.7693ZM1.21038 11.6923C1.21038 12.0615 1.45247 12.3077 1.81567 12.3077H2.48024C2.75384 10.8886 3.96074 9.8462 5.44723 9.8462C6.93372 9.8462 8.14065 10.8887 8.41423 12.3077H14.5262V3.07692C14.5262 2.0923 13.6788 1.23075 12.7104 1.23075H3.02612C2.05769 1.23075 1.21031 2.0923 1.21031 3.07692L1.21038 11.6923Z" fill="#534438"/></svg>';
          }
          else if (lowerText.includes('centro de ayuda') || lowerText.includes('Centro de Ayuda')) {
            svgIcon = '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.08014 8.84553C3.08014 8.59982 3.15963 8.39747 3.31862 8.23848C3.49206 8.06504 3.70164 7.97832 3.94735 7.97832C4.5833 7.94941 5.15421 7.81211 5.66009 7.5664C6.16596 7.30623 6.56343 6.9449 6.8525 6.48239C7.15602 6.00542 7.30778 5.44173 7.30778 4.79133C7.30778 4.18428 7.17047 3.6495 6.89586 3.18699C6.63569 2.72448 6.27436 2.36314 5.81185 2.10298C5.36379 1.84282 4.85792 1.71274 4.29423 1.71274C3.75945 1.71274 3.26081 1.82837 2.7983 2.05962C2.33579 2.29088 1.93831 2.5944 1.60588 2.97019C1.4469 3.12918 1.259 3.23758 1.0422 3.29539C0.83985 3.35321 0.630275 3.30985 0.413473 3.16531C0.167764 2.99187 0.0304556 2.78952 0.00154859 2.55827C-0.0129049 2.31256 0.0738159 2.08853 0.261711 1.88618C0.738676 1.30804 1.33127 0.852755 2.03949 0.520325C2.74771 0.173442 3.49929 0 4.29423 0C5.17589 0 5.97806 0.202349 6.70074 0.607046C7.42341 1.01174 8.00155 1.57543 8.43515 2.2981C8.86876 3.00632 9.08556 3.8374 9.08556 4.79133C9.08556 5.42728 8.96993 6.01265 8.73868 6.54743C8.52187 7.0822 8.21112 7.55917 7.80643 7.97832C7.40173 8.38302 6.93199 8.70822 6.39721 8.95393C5.86243 9.19964 5.2843 9.3514 4.6628 9.40921C4.61944 9.40921 4.61944 9.40921 4.6628 9.40921C4.70616 9.39476 4.74952 9.37308 4.79288 9.34417V11.122C4.79288 11.3677 4.71338 11.5772 4.55439 11.7507C4.39541 11.9241 4.19306 12.0108 3.94735 12.0108C3.68719 12.0108 3.47761 11.9241 3.31862 11.7507C3.15963 11.5772 3.08014 11.3677 3.08014 11.122V8.84553ZM3.90399 16C3.60046 16 3.36921 15.9133 3.21022 15.7398C3.05123 15.5519 2.97174 15.3062 2.97174 15.0027V14.5691C2.97174 14.2656 3.05123 14.0271 3.21022 13.8537C3.36921 13.6802 3.60046 13.5935 3.90399 13.5935H4.09911C4.40263 13.5935 4.63389 13.6802 4.79288 13.8537C4.95187 14.0271 5.03136 14.2656 5.03136 14.5691V15.0027C5.03136 15.3062 4.95187 15.5519 4.79288 15.7398C4.63389 15.9133 4.40263 16 4.09911 16H3.90399Z" fill="#534438"/></svg>';
          }

          a.innerHTML = (svgIcon ? '<span style="display:inline-flex; align-items:center; justify-content: center; width: 30px;">' + svgIcon + '</span>' : '') + '<span>' + linkText + '</span>';
          a.style.display = 'flex';
          a.style.alignItems = 'center';

          footer.appendChild(a);
        });

        body.appendChild(footer);
      }


      panel.appendChild(body);
      this.panelsContainer.innerHTML = '';
      this.panelsContainer.appendChild(panel);
      this.panelStack.push({ level: 1, element: panel });
    },

    goToPanel2: function(megamenuId, megamenuLabel) {
      var megamenu = findMegamenu(megamenuId);

      if (!megamenu || !megamenu.tabs) return;

      var panel = document.createElement('div');
      panel.className = 'mm51-mpanel mm51-mpanel--2';
      panel.dataset.level = '2';

      var header = document.createElement('div');
      header.className = 'mm51-mpanel__header';

      var backBtn = document.createElement('button');
      backBtn.type = 'button';
      backBtn.className = 'mm51-mpanel__back';
      backBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      backBtn.addEventListener('click', this.goBack.bind(this));

      var title = document.createElement('span');
      title.className = 'mm51-mpanel__title';
      title.textContent = megamenuLabel;

      header.appendChild(backBtn);
      header.appendChild(title);
      panel.appendChild(header);

      var body = document.createElement('div');
      body.className = 'mm51-mpanel__body';

      var list = document.createElement('ul');
      list.className = 'mm51-mlist';

      megamenu.tabs.forEach(function(tab) {
        /* 🌟 CORRECCIÓN MOBILE: Se incluye col.type === 'images' como contenido válido navegable */
        var hasNavigableColumns = (tab.columns || []).some(function(col) {
          return col.links || col.columns || col.sizes || col.type === 'images' || (col.images && col.images.length > 0);
        });

        var li = document.createElement('li');
        li.className = 'mm51-mlist__item';

        var a = document.createElement('a');
        a.href = '#';
        a.className = 'mm51-mlist__link';

        var tabLabel = _getText(tab);
        var span = document.createElement('span');
        span.textContent = tabLabel;
        a.appendChild(span);

        if (hasNavigableColumns) {
          var arrow = document.createElement('span');
          arrow.className = 'mm51-mlist__arrow';
          arrow.innerHTML = _arrowSvg();
          a.appendChild(arrow);

          a.addEventListener('click', function(e) {
            e.preventDefault();
            mobileDrawer.goToPanel3(megamenu.id, megamenuLabel, tab, tabLabel);
          });
        }

        li.appendChild(a);
        list.appendChild(li);
      });

      body.appendChild(list);
      panel.appendChild(body);

      this.addPanel(panel);
    },

    goToPanel3: function(megamenuId, megamenuLabel, tab, tabLabel) {
      var panel = document.createElement('div');
      panel.className = 'mm51-mpanel mm51-mpanel--3';
      panel.dataset.level = '3';

      // Validamos los nombres
      var menuName = (megamenuLabel || '').trim().toLowerCase();
      var tabName = (tabLabel || '').trim().toLowerCase();
      var isMarcasTodas = (menuName === 'marcas' && tabName === 'todas');

      var header = document.createElement('div');
      header.className = 'mm51-mpanel__header';

      var backBtn = document.createElement('button');
      backBtn.type = 'button';
      backBtn.className = 'mm51-mpanel__back';
      backBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      backBtn.addEventListener('click', this.goBack.bind(this));

      var breadcrumb = document.createElement('span');
      breadcrumb.className = 'mm51-mpanel__breadcrumb';
      breadcrumb.textContent = megamenuLabel + ' • ' + tabLabel;

      header.appendChild(backBtn);
      header.appendChild(breadcrumb);
      panel.appendChild(header);

      var body = document.createElement('div');
      body.className = 'mm51-mpanel__body';

      // Creamos el ul general
      var list = document.createElement('ul');
      list.className = 'mm51-mlist';

      // AQUÍ AGREGAMOS LA CLASE AL UL SI ES MARCAS > TODAS
      if (isMarcasTodas) {
        list.classList.add('promo-wrapper-all');
      }

      var navigableColumns = (tab.columns || []).filter(function(col) {
        return col.type !== 'images' && (col.links || col.columns || col.sizes);
      });

      navigableColumns.forEach(function(col) {
        var li = document.createElement('li');
        li.className = 'mm51-mlist__item';

        var a = document.createElement('a');
        a.href = '#';
        a.className = 'mm51-mlist__link';

        var span = document.createElement('span');
        span.textContent = _getText(col.title || col) || 'Sin título';
        a.appendChild(span);

        var arrow = document.createElement('span');
        arrow.className = 'mm51-mlist__arrow';
        arrow.innerHTML = _arrowSvg();
        a.appendChild(arrow);

        a.addEventListener('click', function(e) {
          e.preventDefault();
          mobileDrawer.goToPanel4(megamenuId, megamenuLabel, tab, tabLabel, col);
        });

        li.appendChild(a);
        list.appendChild(li);
      });

      var imageColumns = (tab.columns || []).filter(function(col) {
        return col.type === 'images' || (col.images && col.images.length > 0);
      });

      /* Grid de 12 columnas: cada columna respeta col.width.mobile vía --col-mobile */
      var imageGrid = document.createElement('div');
      imageGrid.className = 'mm51-mgrid';

      imageColumns.forEach(function(col) {
        if (!col.images || !col.images.length) return;

        var colEl = document.createElement('div');
        colEl.className = 'mm51-mgrid__col';
        colEl.style.setProperty('--col-mobile', (col.width && col.width.mobile) || 12);

        col.images.forEach(function(img) {
          var imgLink = document.createElement('a');
          imgLink.href = img.url || '#';
          imgLink.className = 'mm51-mlist__promo-link';

          var imgEl = document.createElement('img');
          imgEl.src = img.src;
          imgEl.alt = img.alt || _getText(col.title || col) || _getText(img) || '';
          imgEl.loading = 'lazy';

          imgLink.appendChild(imgEl);

          var captionText = _getText(col.title || col) || img.alt || _getText(img);
          if (captionText) {
            var caption = document.createElement('span');
            caption.className = 'mm51-mlist__promo-caption';
            caption.textContent = captionText;
            imgLink.appendChild(caption);
          }

          colEl.appendChild(imgLink);
        });

        imageGrid.appendChild(colEl);
      });

      if (list.children.length) body.appendChild(list);
      if (imageGrid.children.length) body.appendChild(imageGrid);
      panel.appendChild(body);
      _appendMobileTabFooter(panel, tab);

      this.addPanel(panel);
    },


    goToPanel4: function(megamenuId, megamenuLabel, tab, tabLabel, column) {
      var panel = document.createElement('div');
      panel.className = 'mm51-mpanel mm51-mpanel--4';
      panel.dataset.level = '4';

      var header = document.createElement('div');
      header.className = 'mm51-mpanel__header';

      var backBtn = document.createElement('button');
      backBtn.type = 'button';
      backBtn.className = 'mm51-mpanel__back';
      backBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      backBtn.addEventListener('click', this.goBack.bind(this));

      var breadcrumb = document.createElement('span');
      breadcrumb.className = 'mm51-mpanel__breadcrumb';
      breadcrumb.textContent = megamenuLabel + ' • ' + tabLabel + ' • ' + (_getText(column.title || column));

      header.appendChild(backBtn);
      header.appendChild(breadcrumb);
      panel.appendChild(header);

      var body = document.createElement('div');
      body.className = 'mm51-mpanel__body';

      if (column.type === 'links') {
        var list = document.createElement('ul');
        list.className = 'mm51-mlist mm51-mlist--links';

        (column.links || []).forEach(function(link) {
          var li = document.createElement('li');
          li.className = 'mm51-mlist__item';

          var a = document.createElement('a');
          a.href = link.url;
          a.className = 'mm51-mlist__link';
          a.textContent = _getText(link);

          li.appendChild(a);
          list.appendChild(li);
        });

        body.appendChild(list);
      }
      else if (column.type === 'links-multicolumn') {
        var list = document.createElement('ul');
        list.className = 'mm51-mlist mm51-mlist--links';

        (column.columns || []).forEach(function(subCol) {
          subCol.forEach(function(link) {
            var li = document.createElement('li');
            li.className = 'mm51-mlist__item';

            var a = document.createElement('a');
            a.href = link.url;
            a.className = 'mm51-mlist__link';
            a.textContent = _getText(link);

            li.appendChild(a);
            list.appendChild(li);
          });
        });

        body.appendChild(list);
      }
      else if (column.type === 'size-grid') {
        var grid = document.createElement('div');
        grid.className = 'mm51-msize-grid';

        (column.sizes || []).forEach(function(size) {
          var a = document.createElement('a');
          a.href = size.url;
          a.className = 'mm51-msize';
          a.textContent = _getText(size);
          grid.appendChild(a);
        });

        body.appendChild(grid);
      }

      panel.appendChild(body);

      this.addPanel(panel);
    },

    addPanel: function(panel) {
      this.panelsContainer.appendChild(panel);

      var currentPanel = this.panelStack[this.panelStack.length - 1];
      if (currentPanel) {
        currentPanel.element.classList.remove('is-active');
        currentPanel.element.classList.add('is-leaving');
      }

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          panel.classList.add('is-active');
        });
      });

      this.panelStack.push({ level: panel.dataset.level, element: panel });
    },

    goBack: function() {
      if (this.panelStack.length <= 1) return;

      var currentPanel = this.panelStack.pop();
      var previousPanel = this.panelStack[this.panelStack.length - 1];

      currentPanel.element.classList.remove('is-active');
      currentPanel.element.classList.add('is-exiting');

      if (previousPanel) {
        previousPanel.element.classList.remove('is-leaving');
        previousPanel.element.classList.add('is-active');
      }

      setTimeout(function() {
        if (currentPanel.element.parentNode) {
          currentPanel.element.parentNode.removeChild(currentPanel.element);
        }
      }, 300);
    }
  };

  /* ════════════════════════════════════════════════
     INICIALIZACIÓN
  ════════════════════════════════════════════════ */
  function init() {
    menuData = window.MM51_DATA;
    if (!menuData) {
      console.warn('[MM51] window.MM51_DATA no está definido.');
      return;
    }

    render();
    attachGlobalEvents();
    setMmTop();
    mobileDrawer.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (
      e.target && (
        e.target.querySelector('#mm51-navbar') ||
        e.target.querySelector('#mm51-panels') ||
        e.target.querySelector('[data-mm51-open]')
      )
    ) {
      if (menuData) {
        render();
        setMmTop();
        mobileDrawer.init();
      } else {
        init();
      }
    }
  });

})();